import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { EKeyCode } from '@/enums/e_key_code';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { WATCHER_SHORTCUT__base } from '@/pages/_base/shortcuts/_watchers/WATCHER_SHORTCUT__base';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useRef } from 'react';
import { HOOK_COLLECTION__create } from '../_hooks/HOOK_COLLECTION__create';

export function WatcherShortcutCollectionsCreate() {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { create_collection, is_loading } = HOOK_COLLECTION__create();

  const ref_last_created_at = useRef(NaN);

  /*
   * EVENTS
   */
  function on_shortcut_pressed() {
    if (is_loading) return false;
    if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_CREATE)) return false;

    let timenow = timestamp_ms();
    if (!isNaN(ref_last_created_at.current) && timenow - ref_last_created_at.current <= CONSTANTS_TIME__client.THROTTLE_COLLECTION_CREATE) return false;

    ref_last_created_at.current = timenow;

    void create_collection(true);

    return true;
  }

  /*
   * HTML
   */

  if (is_loading) return null;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_CREATE)) return null;

  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.C]} {...{ on_shortcut_pressed }} />;
}
